module.exports = __webpack_public_path__ + "static/img/icon_train_current.455175f5.png";